// extracted by mini-css-extract-plugin
module.exports = {"imageCarousel":"Carousel_imageCarousel__25Ckm"};